module.exports = __webpack_public_path__ + "media/images/weather-icons/fill/thermometer-colder-88b91af5f3ec11036126a092ea0d0365.svg";